export const recentColumns = [
  "createdDateTime_dtm",
  "title_chr",
  "collectionMemberships",
  "sourceName_chr",
  "sourcePublishedDateTime_dtm",
  "score",
  "mediaBiasRating",
  "charityNavigatorSource",
  // "isSummaryAvailable_ysn",
  "isCitationAvailable_ysn",
  "notesCount_cnt",
  "isReadingLevelAvailable_ysn",
];

export const singleCollectionColumns = [
  "createdDateTime_dtm",
  "collectionMemberships",
  "title_chr",
  "sourceName_chr",
  "sourcePublishedDateTime_dtm",
  "score",
  "mediaBiasRating",
  "charityNavigatorSource",
  // "isSummaryAvailable_ysn",
  "notesCount_cnt",
  "isCitationAvailable_ysn",
  "isReadingLevelAvailable_ysn",
];

export const singleCollectiondefaultVisibilityModel = {
  createdDateTime_dtm: false,
  title_chr: true,
  sourceName_chr: true,
  sourcePublishedDateTime_dtm: true,
  score: true,
  mediaBiasRating: true,
  charityNavigatorSource: false,
  isCitationAvailable_ysn: true,
  isReadingLevelAvailable_ysn: false,
  notesCount_cnt: true,
  collectionMemberships: false,
};

export const defaultVisibilityModel = {
  createdDateTime_dtm: false,
  title_chr: true,
  sourceName_chr: true,
  sourcePublishedDateTime_dtm: true,
  score: true,
  mediaBiasRating: true,
  charityNavigatorSource: false,
  isCitationAvailable_ysn: true,
  isReadingLevelAvailable_ysn: false,
  notesCount_cnt: true,
  collectionMemberships: true,
};

export const publicCollectionColumns = [
  "createdDateTime_dtm",
  "title_chr",
  "sourceName_chr",
  "sourcePublishedDateTime_dtm",
  "score",
  "mediaBiasRating",
  "charityNavigatorSource",
];

export const publicCollectiondefaultVisibilityModel = {
  createdDateTime_dtm: true,
  title_chr: true,
  sourceName_chr: true,
  sourcePublishedDateTime_dtm: true,
  score: false,
  mediaBiasRating: false,
  charityNavigatorSource: false,
};

export const publicCollectionsListColumns = [
  "lastUpdatedDateTime_dtm",
  "collectionName_chr",
  "userName_chr",
  "publicCollectionSource_Count_int",
];

export const publicCollectionsListdefaultVisibilityModel = {
  lastUpdatedDateTime_dtm: true,
  collectionName_chr: true,
  userName_chr: true,
  publicCollectionSource_Count_int: true,
};